import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=62642b37&scoped=true&"
import script from "./VehicleForm.vue?vue&type=script&lang=js&"
export * from "./VehicleForm.vue?vue&type=script&lang=js&"
import style0 from "./VehicleForm.vue?vue&type=style&index=0&id=62642b37&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62642b37",
  null
  
)

export default component.exports